module.exports = __webpack_public_path__ + "static/img/home_adv_photo3@2x.504c918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/ourAdvantage/home_adv_photo3@2x.png
// module id = Nbm6
// module chunks = 0